module.exports = __webpack_public_path__ + "static/media/home.87c905bf.png";